<script setup lang="ts">
  import { useEnvironmentsStore } from '@/stores/environments';

  const errorStatus = ref(null);
  const environmentsStore = useEnvironmentsStore();

  onBeforeMount(async () => {
    try {
      await environmentsStore.getEnvironments();
    } catch (error: any) {
      errorStatus.value = error.status;
    }
  });
</script>

<template>
  <VToast />
  <RouterView v-if="!errorStatus" />
  <VErrorLayout v-else :status="errorStatus" />
</template>
